import type { Content } from "@prismicio/client";
import type { SliceComponentProps } from "@prismicio/react";

import UIKitSectionDivider, {
  type SectionDividerProps as UIKitSectionDividerProps,
} from "@ui-kit/SectionDivider";

import { SliceBox } from "@cms/components/SliceBox";

/**
 * Props for `SectionDivider`.
 */
export type SectionDividerProps =
  SliceComponentProps<Content.SectionDividerSlice>;

const getProps = (
  slice: Content.SectionDividerSlice,
): UIKitSectionDividerProps => {
  return {
    title: slice.primary.title || "",
    caption: slice.primary.caption || "",
    linePosition: slice.primary.line_position || "bottom",
    variant: slice.variation || "divider",
  };
};

/**
 * Component for "SectionDivider" Slices.
 */
const SectionDivider = ({ slice, index }: SectionDividerProps): JSX.Element => {
  return (
    <SliceBox slice={slice} index={index}>
      <UIKitSectionDivider {...getProps(slice)} />
    </SliceBox>
  );
};

export default SectionDivider;
